export const CognitoGroups = {
    ADMIN: "IdwalAdministrators",
    SURVEYOR: "IdwalSurveyors",
    DOC_COLLECTION: "DOCUMENT_COLLECTION",
    FLEET_USER: "FleetApp",
    FLEET_PREMIUM_USER: "FleetAppPremiumUser",
    FLEET_TECHNICAL_MANAGER: "FleetTechnicalManager",
    FLEET_THIRD_PARTY: "FleetThirdPartyAccess"
};
